import { ENTITY_NAME } from '@esentai/core/features/bonus_transactions/consts';

export const RETRY_FETCH = `${ENTITY_NAME}/RETRY_FETCH`;
